<template>
	<div class="drawer">
		<el-drawer
		size="1000px"
		title="添加过敏情况"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<div class="drawerContent">
				<div style="height: 100%;overflow: auto;">
					<el-table class="table" :data="recipelItem" style="width: 100%;padding:0;">
						<el-table-column label="药品名称" min-width="150" prop="goodsName">
						</el-table-column>
						<el-table-column label="规格" min-width="250" prop="goodsName">
							<template slot-scope="props">
								{{props.row.skuValue}}
								<el-input
								disabled
								v-model="props.row.num"
								style="width:60px;"
								size="small">
								</el-input>
								{{props.row.unit}}
								<el-input
								disabled
								v-model="props.row.goodsDosage"
								style="width:60px;"
								size="small">
								</el-input>
								{{props.row.outUnit}}
							</template>
						</el-table-column>
						<el-table-column label="用法" min-width="160" prop="goodsName">
							<template slot-scope="props">
								<span v-if="props.row.goodsUsage.length===5">
									{{props.row.goodsUsage[0]}} {{props.row.goodsUsage[1]}}天{{props.row.goodsUsage[2]}}次 每次{{props.row.goodsUsage[3]}}{{props.row.goodsUsage[4]}}
								</span>
								<span v-else>无</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" min-width="160" prop="goodsName">
							<template slot-scope="props">
								<el-select style="width:180px;" v-model="props.row.tag" multiple placeholder="请选择" size="small">
									<el-option v-for="item in [
										{label:'呼吸抑制',value:'呼吸抑制'},
										{label:'心脏骤停',value:'心脏骤停'},
										{label:'全身荨麻疹',value:'全身荨麻疹'},
										{label:'高热',value:'高热'},
										{label:'紫癜',value:'紫癜'},
										{label:'脑水肿',value:'脑水肿'},
										{label:'一般症状精神异常',value:'一般症状精神异常'},
										{label:'食欲不振',value:'食欲不振'},
										{label:'呕吐腹泻',value:'呕吐腹泻'},
										{label:'瘙痒',value:'瘙痒'},
										{label:'脱毛',value:'脱毛'},
										{label:'水肿',value:'水肿'},
									]" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="btnBox">
					<div class="btnItem" @click="close">取消</div>
					<div class="btnItem submit" @click="submit">确定</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				recipelItem:[],
			}
		},
		computed:{
		},
		props:{
			blItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true
			})
			this.recipelItem = JSON.parse(JSON.stringify(this.blItem.recipelItem))
			this.getList()
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				let arr = []
				for(let i=0;i<this.recipelItem.length;i++){
					arr.push({
						"id": this.recipelItem[i].allergyId,  // 
						"petId": this.blItem.petId,
						"allergyGoods": {
							"goodsId": this.recipelItem[i].goodsId,
							"goodsName": this.recipelItem[i].goodsName,
							"count":this.recipelItem[i].num,
							"unit": this.recipelItem[i].unit,
							"outUnit": this.recipelItem[i].outUnit,
							"goodsDosage": this.recipelItem[i].goodsDosage,
							"goodsUsage": this.recipelItem[i].goodsUsage,
						},
						"symptom": this.recipelItem[i].tag,
						// "level": 0,
						// "useTime": "string",
						"caseNumber": this.blItem.caseNumber,
					})
				}
				let params = arr
				let loading = this.$loading()
				this.$http.post('/api/Case/AllergyHistory/Add', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						// this.$emit("submit",{type:'success'})
					}
				})
			},
			// 保存基本信息
			getList() {
				let params = {
					caseNumber:this.blItem.caseNumber,
				}
				let loading = this.$loading()
				this.$http.get('/api/Case/AllergyHistory/ListByCaseNumber', params).then(res => {
					loading.close();
					if (res.code == 0) {
						for(let i=0;i<this.recipelItem.length;i++){
							this.$set(this.recipelItem[i],'tag',[])
							this.$set(this.recipelItem[i],'allergyId','')
							for(let a=0;a<res.data.length;a++){
								if(this.recipelItem[i].goodsId===res.data[a].allergyGoods.goodsId){
									this.$set(this.recipelItem[i],'tag',res.data[a].symptom)
									this.$set(this.recipelItem[i],'allergyId',res.data[a].id)
								}
							}
						}
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		::v-deep .el-drawer{
			.el-drawer__header{
				margin-bottom: 10px;
			}
			.el-drawer__body{
				height: calc(100% - 54px);
			}
		}
	}
	.drawerContent{
		height: 100%;padding-bottom:40px;box-sizing: border-box;
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
</style>
